/* eslint-disable @ngrx/avoid-dispatching-multiple-actions-sequentially */
/* eslint-disable @typescript-eslint/naming-convention */
import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import firebase from 'firebase/compat/app';
import { LearningService } from 'src/app/pages/app/learning/service/learning.service';
import { RudderStack } from 'src/app/services';
import { environment } from 'src/environments/environment';
import { AssignmentService } from './services/assignment.service';

@Component({
	selector: 'app-assignment-editor',
	templateUrl: './assignment-editor.component.html',
	styleUrls: ['./assignment-editor.component.scss'],
})
export class AssignmentEditorComponent implements OnInit {
	@Input() submissionId: any = '';
	@Input() assignmentId = '';
	cohortId: number;
	@Input() readOnly: boolean;
	public localComments = {};

	currentUser: any = firebase.auth().currentUser;

	tinycomments_create = async (req, done, fail) => {
		const { content, createdAt } = req;

		await this.http
			.post<any>(`${environment.url.cohort}/assignment/submission/comment`, {
				content,
				email: this.currentUser.email,
				name: this.currentUser.displayName,
				assignmentId: this.assignmentId,
				assignmentSubmissionId: this.submissionId,
			})
			.toPromise()
			.then(req2 => {
				const conversationUid = req2.id;
				done({ conversationUid });
			})
			.catch(e => {
				fail(e);
			});
	};

	tinycomments_reply = async (req, done, fail) => {
		const { conversationUid, content, createdAt } = req;

		const parent = this.localComments[conversationUid][0];

		await this.http
			.post<any>(`${environment.url.cohort}/assignment/submission/comment`, {
				content,
				email: this.currentUser.email,
				name: this.currentUser.displayName,
				assignmentId: this.assignmentId,
				assignmentSubmissionId: this.submissionId,
				parentCommentId: Number(conversationUid),
				replyTo: parent.email !== this.currentUser.email ? parent.email : null,
				replyToName:
					parent.authorName !== this.currentUser.displayName
						? parent.authorName
						: null,
			})
			.toPromise()
			.then(req2 => {
				const commentUid = req2.id;
				done({ commentUid });
			})
			.catch(e => {
				fail(e);
			});
	};

	tinycomments_edit_comment = (req, done, fail) => {
		const { conversationUid, commentUid, content, modifiedAt } = req;

		this.http
			.put<any>(
				`${environment.url.cohort}/assignment/submission/comment/${conversationUid}`,
				{ content, modifiedAt },
			)
			.toPromise()
			.then(req2 => {
				done({ canEdit: true });
			})
			.catch(e => {
				fail(e);
			});
	};

	tinycomments_delete = (req, done, fail) => {
		const conversationUid = req.conversationUid;
		this.http
			.delete<any>(
				`${environment.url.cohort}/assignment/submission/comment/${conversationUid}`,
			)
			.toPromise()
			.then(response => {
				if (response.count != 0) {
					done({ canDelete: true });
				} else if (response.status === 403) {
					done({ canDelete: false });
				} else {
					fail(new Error('Something has gone wrong...'));
				}
			});
	};

	tinycomments_delete_all = (_req, done, fail) => {
		this.http
			.delete<any>(
				`${environment.url.cohort}/assignment/submission/${this.submissionId}/comments`,
			)
			.toPromise()
			.then(response => {
				if (response.count != 0) {
					done({ canDelete: true });
				} else if (response.status === 403) {
					done({ canDelete: false });
				} else {
					fail(new Error('Something has gone wrong...'));
				}
			});
	};

	tinycomments_delete_comment = (req, done, fail) => {
		const { conversationUid, commentUid } = req;

		this.http
			.delete<any>(
				`${environment.url.cohort}/assignment/submission/comment/${commentUid}`,
			)
			.toPromise()

			.then(response => {
				if (response.count != 0) {
					done({ canDelete: true });
				} else if (response.status === 403) {
					done({ canDelete: false });
				} else {
					fail(new Error('Something has gone wrong...'));
				}
			});
	};

	tinycomments_lookup = ({ conversationUid }, done, fail) => {
		const lookup = async () => {
			const comments: any = await this.http
				.get(
					`${environment.url.cohort}/assignment/submission/comment/${conversationUid}`,
				)
				.toPromise();

			const match = comments.data[0];

			const subReplay = [];

			match.replies.filter(r => {
				if (Object.keys(r).length !== 0) {
					subReplay.push({
						...r,
						uid: r.id,
						content: r.content,
						authorName: r.name,
						author: r.name,
						createdAt: new Date(r.updatedAt),
						modifiedAt: new Date(r.updatedAt),
					});
				}
			});
			return {
				conversation: {
					uid: conversationUid,
					comments: [
						{
							...match,
							uid: match.id,
							content: match.content,
							authorName: match.name,
							author: match.name,
							createdAt: new Date(match.updatedAt),
							modifiedAt: new Date(match.updatedAt),
						},
						...subReplay,
					],
				},
			};
		};
		lookup()
			.then(data => {
				this.localComments[conversationUid] = data.conversation.comments;
				done(data);
			})
			.catch(err => {
				fail(err);
			});
	};

	example_image_upload_handler = async (blobInfo, progress) => {
		const formData = new FormData();
		formData.append('file', blobInfo.blob(), blobInfo.filename());

		const media: any = await this.http
			.post(`${environment.url.profile}/upload/assignments`, formData)
			.toPromise();

		return media.url;
	};

	init: any = false;

	content;

	constructor(
		private assignmentService: AssignmentService,
		private http: HttpClient,
		private store: Store,
		private learningService: LearningService,
		private rudderStack: RudderStack,
	) {}

	ngOnInit() {
		const extendObj: any = {
			tinycomments_create: this.tinycomments_create,
			tinycomments_reply: this.tinycomments_reply,
			tinycomments_edit_comment: this.tinycomments_edit_comment,
			tinycomments_delete: this.tinycomments_delete,
			tinycomments_delete_all: this.tinycomments_delete_all,
			tinycomments_delete_comment: this.tinycomments_delete_comment,
			tinycomments_lookup: this.tinycomments_lookup,
			images_upload_handler: this.example_image_upload_handler,
		};

		if (this.readOnly) {
			extendObj.init_instance_callback = editor => {
				editor.getBody().setAttribute('contenteditable', false);
				editor.on('CommentChange', evt => {
					this.assignmentService
						.saveHtml(this.submissionId, editor.getBody().innerHTML)
						.subscribe(() => {});
				});
			};
		}
		this.init = {
			height: 700,
			plugins: this.readOnly ? 'tinycomments' : 'image link table lists',
			toolbar: this.readOnly
				? 'addcomment showcomments'
				: 'blocks | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist checklist | forecolor backcolor casechange permanentpen formatpainter removeformat preview  | insertfile image media pageembed  link  | a11ycheck ltr rtl',
			menubar: '',
			/* The following setup callback opens the comments sidebar when the editor loads */
			setup: editor => {
				editor.on('SkinLoaded', () => {
					editor.execCommand('ToggleSidebar', false, 'showcomments');
				});
			},
			...extendObj,
		};

		this.assignmentService.loadHtml(this.submissionId).subscribe(data => {
			this.content = data.content;
			this.assignmentId = data.assignmentId;
			this.cohortId = data.cohortId;
			localStorage.setItem('assignmentId', this.assignmentId);
		});
	}

	onUpdate() {
		this.rudderStack.log({
			type: 'assignment_save_draft',
			cohortId: this.cohortId,
		});
		this.assignmentService
			.saveHtml(this.submissionId, this.content)
			.subscribe(() => {});
	}

	onSubmit() {
		this.rudderStack.log({
			type: 'assignment_submitted',
			cohortId: this.cohortId,
		});
		this.assignmentService
			.saveHtml(this.submissionId, this.content)
			.subscribe((data: any) => {
				if (data.message) {
					this.assignmentService
						.saveAssignment(this.currentUser.email, this.submissionId)
						.subscribe(response => {
							if (response) {
								this.learningService.editState(
									'assignment',
									this.cohortId,
									this.assignmentId,
									'id',
									'assignmentStatus',
									'Completed',
								);
							}
						});
				}
			});
	}
}
